import { Logger } from '@ps/common-features/sentry/loggerService'
import { PEST_COVERAGE_KEYS } from 'src/api/domains/service-tracking/schemas/serviceTracking.schema'
import type { TrackingPest } from 'src/api/domains/service-tracking/serviceTracking.types'

import { TreatmentStatus } from '../constants/treatment'

export const resolveTreatmentStatus = (
  requestPestStatusSlug: TrackingPest['status']['slug'],
  workOrderPestStatusSlug?: TrackingPest['status']['slug'],
  logContext?: {
    requestNumber?: number
    workOrderId?: number
    providerName?: string
  },
): TreatmentStatus => {
  // 1. Use a recognized work-order status when one exists
  switch (workOrderPestStatusSlug) {
    case PEST_COVERAGE_KEYS.COVERED:
      if (requestPestStatusSlug === PEST_COVERAGE_KEYS.PAID_TENANT) return TreatmentStatus.Paid
      if (requestPestStatusSlug === PEST_COVERAGE_KEYS.PAID_PM) return TreatmentStatus.Approved
      return TreatmentStatus.Covered
    case PEST_COVERAGE_KEYS.WARRANTY:
      return TreatmentStatus.Covered
    case PEST_COVERAGE_KEYS.QUOTE_TENANT:
      return TreatmentStatus.QuoteAtTimeOfService
    case PEST_COVERAGE_KEYS.QUOTE_PESTSHARE:
      return TreatmentStatus.NeedsReview
  }

  // 2. Otherwise, map the request status
  switch (requestPestStatusSlug) {
    case PEST_COVERAGE_KEYS.RED_BUCKET:
      return TreatmentStatus.NeedsReview
    case PEST_COVERAGE_KEYS.COVERED:
      return TreatmentStatus.Covered
    case PEST_COVERAGE_KEYS.WARRANTY:
      return TreatmentStatus.NeedsReview
    case PEST_COVERAGE_KEYS.NEEDS_ADDITIONAL_INFO:
      return TreatmentStatus.PropertyManagerReview
    case PEST_COVERAGE_KEYS.NOT_COVERED:
      return TreatmentStatus.NotCovered
    case PEST_COVERAGE_KEYS.QUOTE_TENANT:
      return TreatmentStatus.Hidden
    case PEST_COVERAGE_KEYS.PAID_TENANT:
      return TreatmentStatus.Paid
    case PEST_COVERAGE_KEYS.REJECTED_BY_TENANT:
      return TreatmentStatus.Declined
    case PEST_COVERAGE_KEYS.EXPIRED_TENANT:
      return TreatmentStatus.Declined
    case PEST_COVERAGE_KEYS.PAID_PM:
      return TreatmentStatus.Approved
    case PEST_COVERAGE_KEYS.NEEDS_INFO_TENANT:
      return TreatmentStatus.PaymentRequired
    case PEST_COVERAGE_KEYS.EXPIRED_PM:
      return TreatmentStatus.NotApproved
    case PEST_COVERAGE_KEYS.REJECTED_PM:
      return TreatmentStatus.NotApproved
    default:
      Logger.error('Invalid pest status: unknown request pest status', {
        context: {
          ...logContext,
          requestPestStatusSlug,
          workOrderPestStatusSlug,
        },
      })
      return TreatmentStatus.Hidden
  }
}
